import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import { queryKeys } from '@/libs/queryKeys';
import { getFullImageUrl } from '@/utils/url';
import type { Echo } from '@/types';

/** React Query for the public-discovery echo list, mapped to the `Echo` UI shape with absolute media URLs. */
export const usePublicEchoesQuery = () =>
  useQuery({
    queryKey: queryKeys.echoes.public(),
    queryFn: async () => {
      const response = await api.echoes.getPublicEchoes(100, 0);

      // Perform data mapping immediately within the query function
      return response.echoes.map(
        (e): Echo => ({
          id: e.id,
          name: e.name,
          category: e.category || 'General',
          domain: e.domain || 'General',
          imageUrl: getFullImageUrl(e.profile_image_url) ?? null,
          videoAvatarUrl: e.video_avatar_url ? (getFullImageUrl(e.video_avatar_url) ?? null) : null,
          videoMessagesEnabled: e.video_messages_enabled ?? false,
          idleVideoUrl: e.idle_video_url ? (getFullImageUrl(e.idle_video_url) ?? null) : null,
          ...(e.bio ? { bio: e.bio } : {}),
          createdAt: e.created_at,
        })
      );
    },
  });
